module.exports = __webpack_public_path__ + "static/img/All@2x.c8e8295f.jpg";